/**
 * Contrato del listado de recepciones COMPLETADAS — anmat_task con
 * estado='trazado' filtradas por GLN. Cada item es un remito ya confirmado
 * al SNT.
 */

import { z } from 'zod';

export const RecepcionCompletadaSchema = z.object({
  id: z.number().int(),
  nRemito: z.string().nullable(),
  nFactura: z.string().nullable(),
  glnOrigen: z.string().nullable(),
  glnDestino: z.string().nullable(),
  razonSocialOrigen: z.string().nullable(),
  razonSocialDestino: z.string().nullable(),
  cantSeries: z.number().int().min(0),
  /** trazado | parcial | error | anulada | confirmando */
  estado: z.string(),
  stockDestino: z.string().nullable().optional(),
  tracedAt: z.string().nullable(),
  cerradoAt: z.string().nullable().optional(),
  cerradoPor: z.string().nullable().optional(),
  createdAt: z.string().nullable(),
  sobrantes: z.number().int().min(0).optional(),
  totales: z.object({
    total: z.number().int().min(0),
    trazado: z.number().int().min(0),
    error: z.number().int().min(0),
    noRecibida: z.number().int().min(0).optional(),
    anulada: z.number().int().min(0).optional(),
    marcada: z.number().int().min(0).optional(),
    pendiente: z.number().int().min(0).optional(),
  }),
});

export const RecepcionCompletadasResponse = z.object({
  items: z.array(RecepcionCompletadaSchema),
  total: z.number().int().min(0),
  limit: z.number().int().min(1),
  offset: z.number().int().min(0),
});

export type RecepcionCompletada = z.infer<typeof RecepcionCompletadaSchema>;
export type RecepcionCompletadas = z.infer<typeof RecepcionCompletadasResponse>;

export interface RecepcionCompletadasFilters {
  search?: string;
  /** YYYY-MM-DD */
  dateFrom?: string;
  /** YYYY-MM-DD */
  dateTo?: string;
  /** Lista separada por coma de estados del acta (default: todas las cerradas). */
  estado?: string;
  limit?: number;
  offset?: number;
}
